import axios from 'axios';
import router from '../../router';
import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import store from '~/store';
import constants from 'Helpers/constants';
import utils from '../../helpers/utils';

const vm = new Vue();

export default {
    namespaced: true,
    state: {
        errorMessage: '',
        isShowSendVerifyEmailLink: false,
    },
    mutations: {
        setErrorMessage(state, errorMessage) {
            state.errorMessage = errorMessage;
        },
        setIsShowSendVerifyEmailLink(state, isShowSendVerifyEmailLink) {
            state.isShowSendVerifyEmailLink = isShowSendVerifyEmailLink;
        },
    },
    getters: {
        getErrorMessage(state) {
            return state.errorMessage;
        },
        getIsShowSendVerifyEmailLink(state) {
            return state.isShowSendVerifyEmailLink;
        },
    },
    actions: {
        logout(context) {
            axios.get('/api/logout').then((response) => {
                if (response.data.success) {
                    localStorage.removeItem('refreshTime');
                    localStorage.removeItem('user');
                    localStorage.removeItem('token');
                    // context.commit('setErrorMessage', '');

                    context.commit('setUniqAppId', uuidv4(), { root: true });

                    if (vm.$socket && vm.$socket.readyState) {
                        vm.$disconnect(); //close websocket
                    }

                    //for WL need to re-login user with Guest role
                    if (utils.getPlatform() !== constants.PLATFORM_TRADEBALL) {
                        let params = {
                            ccy: store.getters['AppModule/getCcy'],
                            lang: store.getters['AppModule/getLang'],
                        };

                        context.commit('resetState', null, { root: true });

                        context
                            .dispatch('AuthModule/guest', params, {
                                root: true,
                            })
                            .then(function () {
                                if (router.currentRoute.name !== 'feedLive') {
                                    router
                                        .push({ name: 'feedLive' })
                                        .then(() => {
                                            location.reload();
                                        })
                                        .catch(() => {});
                                } else {
                                    location.reload();
                                }
                            });
                    } else {
                        // context.commit('resetState', null, { root: true });
                        context.dispatch('UserModule/storeAuth', { token: null, user: null }, { root: true })

                        context.commit('resetStateForModule', 'MenuModule', { root: true })

                        // context.commit('MenuModule/setWithMenu', false, {
                        //     root: true,
                        // });

                        router
                            .push({ name: 'login' })
                            // .then(() => {
                            //     context.dispatch('UserModule/storeAuth', { token: null, user: null }, { root: true });
                            // })
                            // .catch(() => {})
                        ;
                    }
                } else {
                    context.commit('setErrorMessage', response.data.message);
                }
            });
        },

        guest(context, params) {
            let currencyId = constants.CURRENCY_BRL_ID;
            let timeZone = 'America/Sao_Paulo';

            if (params.ccy && params.ccy.toLower === 'eur') {
                currencyId = constants.CURRENCY_EURO_ID;
                timeZone = 'Europe/London';
            } else if (params.ccy && params.ccy.toLower === 'usd') {
                currencyId = constants.CURRENCY_USD_ID;
                timeZone = 'Europe/London';
            }

            let lang = ['en', 'pt'].includes(params.lang) ? params.lang : 'en'

            let user = {
                login: 'Guest',
                type: constants.USER_TYPE_GUEST_ID,
                currency: currencyId,
                timeZone: timeZone,
                lang: lang,
            };

            localStorage.setItem('user', JSON.stringify(user));
            context.dispatch('UserModule/storeAuth', { token: null, user: user }, { root: true });
            context.commit('MenuModule/setWithMenu', false, { root: true });
            context.commit('setErrorMessage', '');
        },

        login(context, params) {
            console.log('Start login');
            let lang = ['en', 'pt'].includes(params.lang) ? params.lang : 'en'
            // axios.get('/sanctum/csrf-cookie').then(() => {
                axios
                    .post('/api/authenticate', {
                        username: params.username,
                        password: params.password,
                        os: params.os,
                        browser: params.browser,
                        token: params.token,
                    })
                    .then((response) => {
                        if (response.data.success) {
                            console.log('Login is successful');
                            let user = JSON.parse(response.data.user);

                            context.dispatch('UserModule/storeAuth', { token: response.data.token, user: user }, { root: true });

                            // localStorage.setItem('token', response.data.token);
                            context.commit('setErrorMessage', '');

                            context.commit('setIsShowSendVerifyEmailLink', false);
                            context.commit('MenuModule/setWithMenu', true, {
                                root: true,
                            });

                            if (vm.$socket && vm.$socket.readyState) {
                                console.log('WS will be disconnected');
                                vm.$disconnect();
                            }
                            console.log('Connect to WS');
                            vm.$connect(utils.getWebSocketURL(response.data.token));

                            if (utils.getPlatform() !== constants.PLATFORM_TRADEBALL) {

                                context.commit('AppModule/setLang', lang, { root: true });
                                context.commit('AppModule/setCcy', params.ccy, {
                                    root: true,
                                });

                                // when I log into an user in the WL platforms, the bets/order card is open automatically, can we avoid that?
                                // localStorage.setItem('isShowBetPanel', true);

                                console.log('Start window listener');
                                //for bet-bra we need to listener for events to set user balance.
                                window.addEventListener('message', (event) => {
                                    console.log('Received event ' + event.type + ' from parent with data: ' + (event.data ? JSON.stringify(event.data) : '[]'));
                                    if (event.data && event.data.type === 'userBalance') {
                                        console.log('Received event userBalance from parent with value: ' + event.data.value);

                                        let credit = parseFloat(event.data.value);

                                        context.dispatch('UserModule/updateUserCredit', { credit: credit }, { root: true });
                                    }
                                });

                                // //for bet-bra after success login we need to send "appReady"
                                // let message = JSON.stringify({
                                //     type: 'appReady',
                                // });
                                //
                                // console.log('Send msg to parent: ' + message);
                                // window.parent.postMessage(message, '*');
                            }

                            if (localStorage.getItem('isStatsAdded') === null) {
                                //temporary solution, we need to show Double Chance columns on first login for players
                                //When you guys release it, remember to set Shots on Target ON by default, but OFF hit woodwork and fouls please
                                if (localStorage.getItem('FeedLiveModuleCustomColumn') !== null) {
                                    let customColumns = JSON.parse(localStorage.getItem('FeedLiveModuleCustomColumn'));

                                    if (customColumns && customColumns.includes('st') === false) {
                                        // st - Shots on Target
                                        customColumns.push('st');
                                        localStorage.setItem('FeedLiveModuleCustomColumn', JSON.stringify(customColumns));
                                    }
                                }

                                if (localStorage.getItem('FeedDballModuleCustomColumn') !== null) {
                                    let customColumns = JSON.parse(localStorage.getItem('FeedDballModuleCustomColumn'));

                                    if (customColumns && customColumns.includes('st') === false) {
                                        customColumns.push('st');
                                        localStorage.setItem('FeedDballModuleCustomColumn', JSON.stringify(customColumns));
                                    }
                                }

                                if (localStorage.getItem('BoardModuleCustomColumn') !== null) {
                                    let customColumns = JSON.parse(localStorage.getItem('BoardModuleCustomColumn'));

                                    if (customColumns && customColumns.includes('st') === false) {
                                        customColumns.push('st');
                                        localStorage.setItem('BoardModuleCustomColumn', JSON.stringify(customColumns));
                                    }
                                }

                                localStorage.setItem('isStatsAdded', true);
                            }

                            if (params.href) {
                                router.push({ path: params.href });
                            } else {
                                router.push({ name: 'feedLive' });
                            }
                        } else {
                            console.log('Login is failed');
                            localStorage.removeItem('user');
                            localStorage.removeItem('token');

                            if (utils.getPlatform() !== constants.PLATFORM_TRADEBALL) {
                                let data = {
                                    lang: lang,
                                    ccy: params.ccy,
                                };

                                context
                                    .dispatch('AuthModule/guest', data, {
                                        root: true,
                                    })
                                    .then(function () {
                                        router.push({ name: 'feedLive' });
                                    });
                            } else {
                                context.commit('setErrorMessage', store.$i18n.t(response.data.message));

                                if (response.data.message === 'login.notVerified') {
                                    context.commit('setIsShowSendVerifyEmailLink', true);
                                } else {
                                    context.commit('setIsShowSendVerifyEmailLink', false);
                                }
                            }
                        }

                        return Promise.resolve(response);
                    });
            // });
        },

        getRegistration(context, params) {
            return axios
                .get('/api/registration', {
                    params: params,
                })
                .then((response) => {
                    if (response.data.success) {
                        context.dispatch('DictionariesModule/setDictionaries', response.data.dictionary, {
                            root: true,
                        });
                    } else {
                        context.commit('setErrorMessage', response.data.message);
                    }

                    return Promise.resolve(response);
                });
        },

        registration(context, params) {
            // let self = this;
            return axios
                .post('/api/registration', {
                    ...params,
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },

        forgotPassword(context, params) {
            // let self = this;
            return axios
                .post('/api/forgot-password', {
                    ...params,
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },

        resetPassword(context, params) {
            // let self = this;
            return axios
                .post('/api/reset-password', {
                    ...params,
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },

        sendVerifyEmail(context, params) {
            // let self = this;
            return axios
                .post('/api/send-verify-email', {
                    ...params,
                })
                .then((response) => {
                    if (response.data.success) {
                        context.commit('setErrorMessage', '');
                    }
                    return Promise.resolve(response);
                });
        },
    },
};
